module.exports = __webpack_public_path__ + "static/img/image057.47038fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image057.png
// module id = 58vl
// module chunks = 1